import { AppModule } from 'app/module';
import { Slider } from 'module/slider/main';
import { EbCompanyBenefitsItem } from 'module/ebCompanyBenefitsItem/main';
import Template from './template.hbs';
import './styles.scss';

export class EbCompanyBenefits extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            ebCompanyBenefitsItem: '.m-ebCompanyBenefitsItem',
            benefitsItems: ['.m-ebCompanyBenefitsItem'],
            wrapper: '.m-ebCompanyBenefits__wrapper',
            navArrowLeft: '.m-ebCompanyBenefits__arrowLeft',
            navArrowRight: '.m-ebCompanyBenefits__arrowRight',
            sliders: ['.m-slider'],
            hasMoreTablet: 'false',
        };
    }

    getPropsFromDom() {
        return {
            active: this.dom.el.classList.contains('m-bsCompanyBenefitsList--active'),
            categoryTitle: this.dom.wrapper ? this.dom.wrapper.getAttribute('data-category-title') : '',
            hasMore: this.dom.wrapper.getAttribute('data-has-more') === 'true',
        };
    }

    subs() {
        if (this.dom.benefitsItems) {
            const benefitProps = {
                benefitItem: {},
            };

            this.benefitsItems = [];

            for (let i = 0; i < this.dom.benefitsItems.length; i += 1) {
                const newBenefitItems = new EbCompanyBenefitsItem(this.dom.benefitsItems[i]);

                benefitProps.benefitItem[i] = {};
                benefitProps.benefitItem[i] = newBenefitItems.getPropsFromDom();
                this.benefitsItems.push(newBenefitItems);
            }
            this.props = Object.assign(this.props, benefitProps);
        }
        this.initSlider();
    }

    initSlider() {
        this.sliders?.forEach((slider) => {
            slider?.destroy();
        });
        this.sliders = [];
        this.dom.sliders.forEach((sliderElement) => {
            const slider = new Slider(sliderElement);
            slider.setup();
            this.sliders.push(slider);
        });
    }
}
